export default "__VITE_PUBLIC_ASSET__daa69190__"